// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AdminType } from './admin-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountBalance extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  accountBalanceId!: number;
  accountId!: number;
  adminTypeId!: number;
  balance!: number;
  entryCount!: number;
  fxbalance!: number;
  account!: Account;
  adminType!: AdminType;
}

